<template>
  <div>
    <app-link
      v-for="index in links.length"
      :key="index"
      :index="index - 1"
      :link="links[index - 1]"
      @clicked="openLink"
    >
    </app-link>
  </div>
</template>

<script>
import Link from "./Link";
import { getNoorLinks } from "@/api/links";

export default {
  components: {
    appLink: Link,
  },
  data() {
    return {
      links: [],
    };
  },
  created() {
    getNoorLinks()
      .then((response) => {
        const data = response.data;

        if (data) {
          this.links = data;
        }
      })
      .catch((error) => {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
        );
      });
  },

  methods: {
    openLink(index) {
      window.open(this.links[index].LinkAddress);
    },
  },
};
</script>
<style></style>
